/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react/macro";
import { ReactNode } from "react";
import PropsWithCss from "../utilities/PropsWithCss";
import Typo, { TypoName } from "../utilities/Typo";

type TextProps = PropsWithCss<{
  typo?: TypoName;
  center?: boolean;
  component?: "label" | "p";
  html?: string;
  children?: ReactNode;
  color?: string;
  singleLine?: boolean;
  underline?: boolean;
}>;

export default function Text(props: TextProps) {
  const typo = props.typo || "body";
  const textAlign = props.center ? "center" : "left";
  const component = props.component || "p";
  const singleLine = props.singleLine || false;
  const underline = props.underline || false;

  const textCss = css`
    ${Typo[typo]}
    text-align : ${textAlign};
    color: ${props.color || "inherit"};
    flex-shrink: 0;
    ${singleLine ? "white-space: nowrap ;" : ""}
    ${singleLine ? "text-overflow: ellipsis ;" : ""}
    ${singleLine ? "overflow: hidden ;" : ""}
    ${underline ? `text-decoration : underline` : ""}
    strong {
      font-weight: bold;
    }
  `;

  const children = props.children || "\u00A0";

  const content = props.html
    ? { dangerouslySetInnerHTML: { __html: props.html } }
    : { children: children };

  if (component === "label") {
    return <label css={textCss} {...content} className={props.className} />;
  } else {
    return <p css={textCss} {...content} className={props.className} />;
  }
}
